import request, { REQUEST_METHODS } from '@api/Request';
import { DeveloperAccessEndpoints } from './config';
import { GetBannerInfoResponse } from './types';
import { ResponseBase } from '@api/types';
import { useDeveloperStore } from '@stores';

export const DeveloperAccessService = {
  generateSubmittedPdf: async (projectId: string, requestId: string, version: string) => {
    const params = {
      projectID: projectId,
      requestID: requestId,
      version: version,
    };

    return await request({
      url: DeveloperAccessEndpoints.generateSubmittedPdf(),
      method: REQUEST_METHODS.POST,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      params,
    });
  },
  getBannerInfo: async () => {
    const data = await request<GetBannerInfoResponse>({
      url: DeveloperAccessEndpoints.getBannerInfo(),
      method: REQUEST_METHODS.GET,
    });
    useDeveloperStore.setState({ bannerInfo: data.data });
    return data;
  },
  hasRequiredEnvironmentVariables: async () => {
    return await request({
      url: DeveloperAccessEndpoints.hasRequiredEnvironmentVariables(),
      method: REQUEST_METHODS.GET,
    });
  },
  isUrlReachable: async (url: string) => {
    return await request({
      url: DeveloperAccessEndpoints.isUrlReachable(),
      method: REQUEST_METHODS.GET,
      params: { endpoint: url },
    });
  },
  jpaFileMetadataSync: async (createdDate: string) => {
    const dateStringISO = createdDate.concat('T00:00:00Z');
    return await request<ResponseBase>({
      url: DeveloperAccessEndpoints.jpaFileMetadataSync(),
      method: REQUEST_METHODS.POST,
      data: { createdDate: dateStringISO },
    });
  },
  updateBannerStatus: async (isActive: boolean) => {
    return await request({
      url: DeveloperAccessEndpoints.updateBannerStatus(),
      headers: {
        'Content-Type': 'application/json',
      },
      method: REQUEST_METHODS.PUT,
      params: { isBannerOn: isActive },
    });
  },
  updateBannerText: async (text: string) => {
    return await request({
      url: DeveloperAccessEndpoints.updateBannerText(),
      headers: {
        'Content-Type': 'application/json',
      },
      method: REQUEST_METHODS.PUT,
      data: text,
    });
  },
  updateVersion: async (version: string) => {
    return await request({
      url: DeveloperAccessEndpoints.updateVersion(),
      headers: {
        'Content-Type': 'application/json',
      },
      method: REQUEST_METHODS.PUT,
      data: version,
    });
  },
  transferUserProjects: async (originUserEmail: string, destinationUserEmail: string) => {
    return await request({
      url: DeveloperAccessEndpoints.transferUserProjects(),
      headers: {
        'Content-Type': 'text/csv',
      },
      method: REQUEST_METHODS.GET,
      params: { originUserEmail: originUserEmail, destinationUserEmail: destinationUserEmail },
    });
  },
};
